import React from "react";
import { PageHeaderProps } from "./types";

const PageHeader: React.FC<PageHeaderProps> = ({ children }) => {
  return (
    <>
      <div className=" px-3 pt-2 lg:px-6 lg:pt-4 pb-4 ">
        {children}
      </div>
    </>
  );
};

export default React.memo(PageHeader);
